import { render, staticRenderFns } from "./DefaultHeaderComponent.vue?vue&type=template&id=46cb2b8e"
import script from "./DefaultHeaderComponent.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderComponent.vue?vue&type=style&index=0&id=46cb2b8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports